import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=12d48e56&scoped=true&"
import script from "./ProfileUser.vue?vue&type=script&lang=js&"
export * from "./ProfileUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d48e56",
  null
  
)

export default component.exports